import React , { useState }from 'react'

import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';


function PhoneInternational( { thePhone  , theInput }) {

const [phone, setPhone] = useState('');

  function setThePhone( phone , inputValue)
  {

    console.log( "phone = " , phone )
    console.log("inputValue = ", inputValue )
    

    thePhone( phone  ) // El telefono completo
    theInput( inputValue ) // Area code , iso2 , name del pais
    setPhone( phone )

  }


  return (
    <div>
    <PhoneInput
      defaultCountry="mx"
      value={phone}
      onChange={(phone, { country }) => setThePhone(phone ,  country)}
    />



  </div>
  )
}

export default PhoneInternational